import { environment } from "@/env/env.prod";

/**
 * Upload a file directly to Firebase Storage REST API using fetch()
 * @param {File | Blob} file - File or Blob to upload
 * @param {string} path - Path in storage, e.g. "uploads/filename.json"
 * @param {string} authToken - Firebase ID token or custom auth token for authorization
 * @returns {Promise} resolves with upload response JSON
 */
export async function uploadFileCustom(file, path = "uploads/file", authToken) {
  const bucket = "chatapp-55d4a.appspot.com"; // e.g. "my-app.appspot.com"

  // Encode the path to be URL-safe
  const encodedPath = encodeURIComponent(path);

  // Construct the upload URL
  // Using the "upload" endpoint with "media" upload type for direct upload
  const uploadUrl = environment.USE_EMULATORS
    ? `http://127.0.0.1:9199/v0/b/${bucket}/o?name=${encodedPath}`
    : `https://firebasestorage.googleapis.com/v0/b/${bucket}/o?name=${encodedPath}`;

  try {
    const response = await fetch(uploadUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': file.type || 'application/octet-stream',
      },
      body: file,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Upload failed: ${response.status} ${response.statusText} - ${errorText}`);
    }

    const json = await response.json();
    //console.log(`${file.name || 'file'} uploaded successfully`);
    return json;

  } catch (error) {
    console.error('Custom upload error:', error);
    throw error;
  }
}
